import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { Tabber } from "nectar-ui";
import { HeadingInfoContainer } from "./style";
import { useQuery } from "react-query";
import { fetchLawsuitById } from "@services/lawsuit";
import { NormalText } from "@components/styles/dataDisplay";
import { RouteParams } from "@customTypes/pages/lawsuit";
import LawsuitDataTab from "./tabs/LawsuitDataTab";
import LawsuitDocumentsTab from "./tabs/LawsuitDocumentsTab";
import { CustomHeading } from "@pages/style";
import WithSkeleton from "@components/Skeleton/WithSkeleton";
import { CustomSkeleton } from "@pages/skeletons/style";
import MovementsTab from "./tabs/MovementsTab";
import { CustomButton } from "@pages/HomePage/style";
import { FaArrowLeft } from "@react-icons/all-files/fa/FaArrowLeft";

const LawsuitPage: React.FC = () => {
  const { lawsuitId, _tab } = useParams<RouteParams>();
  const history = useHistory();

  const { data: lawsuit, isLoading } = useQuery({
    queryKey: ["getCase", lawsuitId],
    queryFn: () => fetchLawsuitById({ lawsuitId }),
    enabled: !!lawsuitId,
    keepPreviousData: false,
  });

  const handleBackClick = () => {
    history.replace("/lawsuits");
  };

  return (
    <div>
      <div>
        {isLoading ? (
          <CustomSkeleton marginBottom height={24} />
        ) : (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <CustomHeading noMargin>{lawsuit?.title}</CustomHeading>
            <CustomButton options={{ hideOnMobile: true }} onClick={handleBackClick}>
              <FaArrowLeft /> Voltar
            </CustomButton>
          </div>
        )}
        {!!lawsuit?.actionType && (
          <HeadingInfoContainer>
            <WithSkeleton isLoading={isLoading} height={16} width={256}>
              <NormalText color="gray" semiBold>
                Ação:
              </NormalText>
              <NormalText>{lawsuit?.actionType}</NormalText>
            </WithSkeleton>
          </HeadingInfoContainer>
        )}

        <HeadingInfoContainer>
          <WithSkeleton isLoading={isLoading} height={16} width={256}>
            <NormalText color="gray" semiBold>
              Responsável:
            </NormalText>
            <NormalText>{lawsuit?.responsible}</NormalText>
          </WithSkeleton>
        </HeadingInfoContainer>
      </div>
      <Tabber>
        <Tabber.Tab title={`Dados do ${lawsuit?.type === "CTE_CASE" ? "caso" : "processo"} `}>
          <LawsuitDataTab lawsuitId={lawsuitId} />
        </Tabber.Tab>
        <Tabber.Tab title="Andamentos ">
          <MovementsTab lawsuitId={lawsuitId} />
        </Tabber.Tab>
        <Tabber.Tab title="Documentos ">
          <LawsuitDocumentsTab lawsuitId={lawsuitId} />
        </Tabber.Tab>
      </Tabber>
    </div>
  );
};

export default LawsuitPage;
